'use es6';

import { Record } from 'immutable';
import keyMirror from 'react-utils/keyMirror';
export const States = keyMirror({
  NOT_REQUESTED: null,
  REQUESTED: null,
  SUCCEEDED: null,
  FAILED: null
});

// Represents the state of of API request.
// Each request can have multiple possible states, so one boolean on its own
// isn't enough to track its state. This "enum" works better.
//
// Use RequestStates.REQUESTED, RequestStates.SUCCEEDED, etc, from the exports.
// Use PropTypes.instanceOf(RequestState) to type-check within components.
// Make use of the `should*` methods when using inside of components & actions.
export default class RequestState extends Record({
  state: States.NOT_REQUESTED,
  message: null,
  error: null
}) {
  isNotRequested() {
    return this.state === States.NOT_REQUESTED;
  }
  isPending() {
    return this.state === States.REQUESTED;
  }
  isSuccessful() {
    return this.state === States.SUCCEEDED;
  }
  isFailed() {
    return this.state === States.FAILED;
  }
  isComplete() {
    return this.isSuccessful() || this.isFailed();
  }
  shouldBeRequested() {
    return this.isNotRequested() || this.isFailed();
  }
  shouldShowAsLoading() {
    return this.isNotRequested() || this.isPending();
  }
  hasMessage() {
    return this.getMessage() !== null;
  }
  setMessage(value) {
    return this.set('message', value);
  }
  getMessage() {
    return this.get('message');
  }
  setError(error) {
    return this.set('error', error);
  }
  getError() {
    return this.get('error');
  }
  isErrorCode(code) {
    return (this.getError() || {}).status === code;
  }
  is403() {
    return this.isErrorCode(403);
  }
}
export const NOT_REQUESTED = new RequestState({
  state: States.NOT_REQUESTED
});
export const REQUESTED = new RequestState({
  state: States.REQUESTED
});
export const SUCCEEDED = new RequestState({
  state: States.SUCCEEDED
});
export const FAILED = new RequestState({
  state: States.FAILED
});